export const noAccessToFunctionalityText =
    "Cette fonctionnalité est réservée aux abonnés Immovestor. Débloquez toutes les fonctionnalités exclusives de notre outil dédié aux investisseurs immobiliers, en vous abonnant dès maintenant ! Ne passez plus à coté de nouvelles pépites…";
